<template>
    <!-- <v-container>
        <google-map 
            custom_title="Realtime Monitoring and Trip History Simulation" 
            :realtime_tracking="true"
            :simulated="simulatedDriver"
            :simulatedLinePoints="linePoints"
        />
        <v-row>
            <v-col md="12">
                <generic-data-table v-if="waybills !== undefined && waybills.length > 0"
                    :items="waybills" 
                    :loading="loading" 
                    :headers="waybillHeaders" 
                    :hideAddButton="true"
                    entity_name="wayBill"
                    :localizable_fields="[]"
                    @rowClick="row => simulateRow(row)"
                    no_actions
                >
                </generic-data-table>
            </v-col>
            <v-col md="12">
                <div class="text-center" v-if="loading">
                    <v-progress-circular 
                        :size="50"
                        color="primary"
                        indeterminate
                        style="margin:auto"
                    >
                    </v-progress-circular>
                </div>
                <v-data-table
                    :headers="headers.filter(h=>h.hide_in_table===undefined)"
                    :items="trackingData"
                    :loading="loading"
                    v-if="!reload && trackingData !== undefined && trackingData.length > 0"
                    multi-sort
                >
                </v-data-table>
                <p v-else>
                    No tracking data found
                </p>
            </v-col>
        </v-row>
    </v-container> -->

    <v-card>

        <v-card-text class="d-flex flex-column">

            <v-form style="gap: 16px;" class="d-flex flex-row flex-sm-column flex-lg-row flex-xl-row">

                <div style="display: flex; flex-direction: column; width:100%; max-width: 800px;">

                    <div style="padding: 0;">
                        <v-col no-gutters>
                            <div class="upper-text body-2 mb-4 font-weight-medium">Trip History</div>

                            <v-row no-gutters>
                                <v-col md="12">
                                    <generic-data-table v-if="waybills !== undefined && waybills.length > 0"
                                        :items="waybills" :loading="loading" :headers="waybillHeaders" :hideAddButton="true" :showCardView="false"
                                        entity_name="wayBill" :localizable_fields="[]" @rowClick="row => simulateRow(row)"
                                        no_actions>
                                    </generic-data-table>
                                </v-col>
                            </v-row>
                        </v-col>
                    </div>

                </div>

                <div class="custom-divider"></div>

                <div style="display: flex; flex-direction: column; width:100%; gap: 16px;">

                    <div style="gap: 16px; display: flex; flex-direction: column;" no-gutters>

                        <v-col class="d-flex flex-column" style="justify-content: space-between; gap: 24px; padding: 0 12px"
                            no-gutters>

                            <!-- <div style="gap: 4px;">
                        <div class="upper-text body-2">Media Details</div>
                        <div class="lower-text-gray body-1">Update images here</div>
                        </div> -->

                            <div no-gutters style="padding: 0; height: fit-content;">

                                <v-row no-gutters>
                                    <v-expansion-panels color="primary" accordion>
                                        <v-expansion-panel>
                                            <v-expansion-panel-header>
                                                <v-row style="gap: 12px;" no-gutters>
                                                    <div class="d-flex align-items-center"><v-icon color="primary">{{
                                                        "mdi-map-outline" }}</v-icon></div>
                                                    <div style="gap: 4px;">
                                                        <div class="upper-text body-2 font-weight-medium">Realtime
                                                            monitoring and trip history simulation</div>
                                                        <div class="lower-text-gray body-1">Select a trip from the list.
                                                        </div>
                                                    </div>
                                                </v-row>
                                            </v-expansion-panel-header>
                                            <v-expansion-panel-content>
                                                <div> <google-map :realtime_tracking="true" :simulated="simulatedDriver"
                                                        :simulatedLinePoints="linePoints" /></div>
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-expansion-panels>
                                </v-row>

                            </div>

                            <v-row no-gutters>

                                <v-col md="12">
                                    <div class="text-center" v-if="loading">
                                        <v-progress-circular :size="50" color="primary" indeterminate style="margin:auto">
                                        </v-progress-circular>
                                    </div>
                                    <!-- <v-data-table :headers="headers.filter(h => h.hide_in_table === undefined)"
                                        :items="trackingData" :loading="loading"
                                        v-if="!reload && trackingData !== undefined && trackingData.length > 0" multi-sort>
                                    </v-data-table> -->
                                    <p v-if="!loading && trackingData.length == 0">
                                        No tracking data found
                                    </p>
                                </v-col>

                            </v-row>


                        </v-col>

                    </div>


                </div>

            </v-form>

        </v-card-text>

    </v-card>
</template>
<script>

import GoogleMap from '@/components/GoogleMap';
import GenericDataTable from '@/components/GenericDataTable'
import WayBillHeaders from '../../mixins/waybillHeaders'
export default {
    props: ['driver_id', 'driver', 'truck_id', 'truck', 'delivery_address_id', 'delivery_address'],
    mixins: [WayBillHeaders],

    data() {
        return {
            loading: true,
            waybills: [],
            trackingData: [],
            linePoints: [],
            reload: false,
            driverId: this.driver_id !== undefined ? this.driver_id : 0,
            truckId: this.truck_id !== undefined ? this.truck_id : 0,
            geoRegionId: 0,
            deliveryAddressId: this.delivery_address_id !== undefined ? this.delivery_address_id : 0,
            waybillId: 0,
            center: null,
            simulatedDriver: {
                coordinate: this.center,
                info: {
                    waybillId: 0,
                    dateTime: "",
                    infoWindowOpen: true
                }
            },
            headers: [
                {
                    text: "Driver Id",
                    value: "driverId"
                },
                {
                    text: "Client Id",
                    value: "clientId"
                },
                {
                    text: "Waybill Id",
                    value: "waybillId"
                },
                {
                    text: "Latitude",
                    value: "lat"
                },
                {
                    text: "Longitude",
                    value: "lng"
                }
            ]
        }
    },
    components: { GoogleMap, GenericDataTable },
    methods: {
        loadWaybills() {
            var url = `waybill/filteredList?driverId=${this.driverId}&truckId=${this.truck_id}&geoRegionId=${this.geoRegionId}&deliveryAddressId=${this.deliveryAddressId}`

            axios({
                method: "GET",
                url: `${process.env.VUE_APP_baseURL}${url}`,
            }).then(response => {
                // console.log(response)
                this.waybills = response.data.data
                // console.log(this.waybills)
                this.loading = false
            }).catch(error => {
                console.log(`ERRORRRRRRRRR ${error}`)
            })
        },
        simulateRow(waybill) {
            console.log("simulate")
            this.simulatedDriver.coordinate = null
            this.loadTripHistory(waybill.id)
        },
        // simulateRow(stop) {
        //     // this.simulatedDriver.coordinate = null
        //     this.simulatedDriver.coordinate.lat = stop.lat
        //     this.simulatedDriver.coordinate.lng = stop.lng
        // },
        loadTripHistory(waybillId = 0) {
            this.loading = true
            var url = `app/getTrackingData?driverId=${this.driverId}&truckId=${this.truckId}&deliveryAddressId=${this.deliveryAddressId}&waybillId=${waybillId}`
            axios({
                method: "GET",
                url: `${process.env.VUE_APP_baseURL}${url}`,
            }).then(response => {
                this.trackingData = response.data.data
                this.trackingData.forEach(element => {
                    var lat = parseFloat(element.lat)
                    var lng = parseFloat(element.lng)
                    if (lat !== 0 && lng !== 0) {
                        this.linePoints.push({
                            lat: parseFloat(element.lat),
                            lng: parseFloat(element.lng)
                        })
                    }
                });
                this.loading = false
                this.simulate()
            }).catch(error => {
                console.log(`ERRORRRRRRRRR ${error}`)
            })
        },
        simulate() {
            this.trackingData = this.trackingData.filter(d => d.lng !== undefined && d.lat !== undefined)
            // console.log(this.trackingData) //array of 24 items
            for (var i = 0; i < this.trackingData.length; i++) {
                ((i) => {
                    setTimeout(() => {
                        var t = this.trackingData[i]//undefined
                        this.simulatedDriver.coordinate = {
                            lat: parseFloat(t.lat),
                            lng: parseFloat(t.lng)
                        }
                        this.simulatedDriver.info.waybillId = parseInt(t.waybillId)
                        this.simulatedDriver.info.dateTime = t.timestamp
                    }, 10000 * i);
                })(i);
            }
        }
    },
    mounted() {
        this.loadWaybills()
        navigator.geolocation.getCurrentPosition(position => {
            this.center = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
            };
        });
        //this.loadTripHistory()
    }
}
</script>
<style lang="css" scoped>
.text-center {
    margin: auto;
}
</style>